/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Colors } from '../../../constants';

export default function Info (props) {
  const { datesSelected, timeSlots, color } = props;

  let infoStyles = css`
    display: flex;
    align-items: center;
    margin-left: 10px;
    margin-top: 5px;
    color: #${Colors.black};
  `;
  let textStyles = css`
    color: ${color};
    font-weight: bold;
    margin-left: 10px;
    font-style: normal;
    font-size: 1rem;
    line-height: normal;
  `;

  return (
    <div
      css={css`
        margin-top: 16px;
        flex: 1;
        margin-bottom: 35px;
        margin-left: 20px;
      `}
    >
      <div css={infoStyles}>
        Dates selected:
        <span css={textStyles}>
          {datesSelected || 0}/7
        </span>
      </div>

      <div css={infoStyles}>
        Time slots selected:
        <span css={textStyles}>
          {timeSlots || 0}
        </span>
      </div>
    </div>
  )
}